import { Button, Menu, MenuItem, MenuList } from "@material-ui/core";
import {
  PanoramaVerticalTwoTone,
  PanoramaHorizontalTwoTone,
} from "@material-ui/icons";
import { memo, useState } from "react";
import { orientationOptions } from "../../constants";
import { useResultadoExercicioService } from "../contexts/ResultadoExercicioContext";
const OrientationMenuButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { orientation, setOrientation, orientationLabel, setOrientationLabel } =
    useResultadoExercicioService();

  const handleOpenOptions = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectOrientation = ({ label, value }) => {
    setOrientation(value);
    setOrientationLabel(label);
    handleClose();
  };

  return (
    <>
      <Button
        size="small"
        startIcon={
          orientation === orientationOptions.Retrato ? (
            <PanoramaVerticalTwoTone />
          ) : (
            <PanoramaHorizontalTwoTone />
          )
        }
        color="primary"
        variant="outlined"
        onClick={handleOpenOptions}
      >
        {orientationLabel}
      </Button>
      <Menu
        anchorEl={anchorEl}
        onClose={handleClose}
        open={!!anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <MenuList>
          {Object.entries(orientationOptions).map(([key, value]) => (
            <MenuItem
              value={value}
              key={key}
              onClick={() =>
                handleSelectOrientation({
                  label: key,
                  value: value,
                })
              }
            >
              {key}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </>
  );
};

export default memo(OrientationMenuButton);
